import {
  activeConditionsQuery,
  activeMedicationRequestsQuery,
  medicationRequestsIn,
  type ContextResources,
} from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import type { ProtocolVariables } from '../planner/types';
import { statinsValueSet } from '../valueSets/rxNormDrugClasses';
import { hyperlipidemiaMonitoring } from './hyperlipidemiaMonitoring';

/**
 * Binds exactly the variables `HYPERLIPIDEMIA_CONTEXT_VARIABLES` declares.
 *
 * Statins stand in for lipid-lowering therapy. The guideline's interval is written for anyone on
 * treatment, which also covers ezetimibe and the PCSK9 inhibitors; those classes are not curated yet,
 * so a patient on one of them without a statin reads as untreated and gets the as-needed action
 * rather than the six-monthly one. That is the safe direction to be wrong in — it under-schedules
 * rather than asserting a cadence for someone the guideline did not have in mind — and it is worth
 * closing when those classes land.
 */
export const deriveHyperlipidemiaVariables = (resources: ContextResources): ProtocolVariables => ({
  '%onLipidLoweringTherapy': {
    kind: 'boolean',
    value: medicationRequestsIn(resources, statinsValueSet).length > 0,
  },
});

/** The hyperlipidemia protocol, ready for `planProtocol`. */
export const hyperlipidemiaMonitoringProtocol: ProtocolSpec = {
  planDefinition: hyperlipidemiaMonitoring,
  valueSets: [statinsValueSet],
  queries: [activeConditionsQuery, activeMedicationRequestsQuery],
  deriveVariables: deriveHyperlipidemiaVariables,
};
